export default (s = {},p) => ({...s,...p})